import { QueryFactory, defaultThrowOnError } from '@lmt/shared-types';
import { emptyArray } from '../../helpers/common';

export function useUsers() {
  return (
    QueryFactory.UserQuery.useGetUsersQuery(undefined, {
      throwOnError: defaultThrowOnError,
    }).data ?? emptyArray()
  );
}
export function useGetUserById(userId: string) {
  const users = useUsers();
  return users.find((u) => u.id === userId);
}
